import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import './FrontPage.css';
// import Header from './Header/Header';
import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import { fetchFront } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import Lifts from '../components/Lifts';
import NewsLetter from '../components/NewsLetter/NewsLetter.js';
import Facebook from '../components/Facebook.js';
import Helmet from 'react-helmet';


class FrontPage extends Component {

  componentDidMount() {
    if (!this.props.headField||!this.props.liftField) {
      this.props.fetchFront(this.props.intl.locale, this.props.date);
    }

  }

  render() {
    return (
      <div className="front">
        <div>
          <Helmet title="Levain Bakery Eatery" titleTemplate="%s" />
          {!this.props.headField && <Loader/>}
          {this.props.headField && <FullbleedHero fields={this.props.headField}/>}
          {this.props.lifts.length && <Lifts lifts={this.props.lifts}/>}
          <div className="newsletter-instagram">
            <div className="container">
              <NewsLetter title classname="newsletter"/>
              <div className="facebook">
        		<Facebook />
        	  </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FrontPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  headField:state.front.header,
  instagrams:state.instagrams,
  date:state.date,
  lifts:state.front.lifts?
    state.front.lifts.map(x=>{
      return {
        "align":"Center",
        "heading":x.fields.title,
        "content":x.fields.description,
        "leadLinkText":x.fields.linkText,
        "leadLinkUrl":x.fields.link
      }
    })
    :[]
});

const mapDispatchToProps = {
  fetchFront
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(FrontPage));



// WEBPACK FOOTER //
// ./src/containers/FrontPage.js